module.exports = __webpack_public_path__ + "img/ticket.2ab473ff.webp";